import {observer} from "mobx-react";
import {Bar, BarChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {ChartDataItemReceiptType} from "../../../store";
import {useEffect, useState} from "react";
import {TooltipContent, TooltipCursor} from "./TooltipContent";
import {kpiReceiptStore} from "../../../store/kpi/KpiReceiptStore";
import {displayReceiptType} from "../../../api";
import {ReceiptTypeDto} from "../../../api/kpi";

const colors: Map<ReceiptTypeDto, string> = new Map()

colors.set(ReceiptTypeDto.SCAN_COMPLETE, '#82ca9d')
colors.set(ReceiptTypeDto.ACQUISITION_COMPLETE, '#8884d8')
colors.set(ReceiptTypeDto.PLACEMENT_COMPLETE, '#ffc658')


colors.set(ReceiptTypeDto.SCAN_RECORD_COMPLETE, '#83a6ed')
colors.set(ReceiptTypeDto.ACQUISITION_RECORD_COMPLETE, '#8dd1e1')
colors.set(ReceiptTypeDto.PLACEMENT_RECORD_COMPLETE, '#ff8040')

interface ReceiptsChartProps {
    chartData: ChartDataItemReceiptType[]
    types: ReceiptTypeDto[]
    prefix: string
}

const ReceiptsChart = observer(function ReceiptsChart({
                                                          chartData,
                                                          prefix,
                                                          types
                                                      }: ReceiptsChartProps) {
    const availableTypes = kpiReceiptStore.availableTypes
    const [data, setData] = useState<ChartDataItemReceiptType[]>([])

    useEffect(() => {
        setData(JSON.parse(JSON.stringify(chartData)) as ChartDataItemReceiptType[])
    }, [chartData, availableTypes])

    return <>
        <div style={{
            flex: '1',
            height: '20em'
        }}>
            <ResponsiveContainer>
                <BarChart data={data} responsive={true}>
                    {types.map(t => (
                        <Bar key={`${t}`}
                             dataKey={t}
                             name={`${prefix}${displayReceiptType(t)}`}
                             fill={colors.get(t)}
                        />
                    ))}
                    <XAxis dataKey="date"/>
                    <YAxis/>
                    <Tooltip cursor={<TooltipCursor />} content={TooltipContent}/>
                    <Legend/>
                </BarChart>
            </ResponsiveContainer>
        </div>
    </>
})

export {
    ReceiptsChart
}
